var teamNameUpdated = function(response){
    Do.Notify(response);
    $("#heading-my-team-name").html(response.newname);
};

var sendPersonalInvite = function(slot, data){
    data.slot = slot;
    $("#team-pos-"+slot+" .promana-survey-spinner-bg").removeClass("d-none");
    Do.Ajax("/invite-free",data);
};

var teammateInvited = function (response){
    $("#team-pos-"+response.slot).html(response.partial);
    TeamsFree.initComponents();
    Do.Notify(response);
};

var teammateInviteFailed = function (response){
    $("#team-pos-"+response.slot+" .promana-survey-spinner-bg").addClass("d-none");
    Do.Notify(response);
};

var cancelPersonalInvite = function(data){
    $("#team-pos-"+data.pos+" .promana-survey-spinner-bg").removeClass("d-none");
    Do.Ajax("/invite-free/cancel",data);
};

var inviteCanceled = function (response){
    $("#team-pos-"+response.pos).html(response.partial);
    TeamsFree.initComponents();
    Do.Notify(response);
};

var resendPersonalInvite = function(data){
    $("#team-pos-"+data.pos+" .promana-survey-spinner-bg").removeClass("d-none");
    Do.Ajax("/invite-free/resend",data);
};

var removePersonalTeammate = function(data){
    $("#team-pos-"+data.pos+" .promana-survey-spinner-bg").removeClass("d-none");
    Do.Ajax("/teams/my/personal/remove",data);
};

var personalTeammateRemoved = function(response){
    $("#team-pos-"+response.pos).html(response.partial);
    TeamsFree.initComponents();
    Do.Notify(response);
};

var leaveTeam = function(data){
    Do.Ajax("/teams/leave",data);
};

var leftTeam = function(data){
    // Do.Ajax("/teams/leave",data);
};

var inviteResent = function (response){
    $("#team-pos-"+response.pos).html(response.partial);
    TeamsFree.initComponents();
    Do.Notify(response);
};

var TeamsFree = function () {

    var _updateName = function() {
        $("#update-my-team-name").on("click", function() {
            Do.Ajax("/my-team-name",$("#my-team-name").serializeJSON());
        });
    };

    var _triggerInvitation = function(){
        $(".promana-my-team-invite").on("click", function(){
            var slot = $(this).attr("invite-slot");
            var data = $("#form-invite-"+slot).serializeJSON();
            sendPersonalInvite(slot, data);
        });
    };

    var _cancelInvitation = function(){
        $(".cancel-invitation").on("click", function(){
            var form = $(this).closest("form");
            var data = $(form).serializeJSON();
            cancelPersonalInvite(data);
        });
    };

    var _resendInvitation = function(){
        $(".resend-invitation").on("click", function(){
            var form = $(this).closest("form");
            var data = $(form).serializeJSON();
            data._method = 'POST';
            data["email-"+data.slot] = data.email;
            resendPersonalInvite(data);
        });
    };

    var _removeMember = function(){
        $(".remove-member").on("click", function(){
            var form = $(this).closest("form");
            var data = $(form).serializeJSON();
            removePersonalTeammate(data);
        });
    };

    var _leaveTeam = function(){
        $(".leave-team").on("click", function(){
            var form = $(this).closest("form");
            var data = $(form).serializeJSON();
            leaveTeam(data);
        });
    };

    return {
        initComponents: function() {
            _updateName();
            _triggerInvitation();
            _cancelInvitation();
            _resendInvitation();
            _removeMember();
            _leaveTeam();
        }
    }
}();

document.addEventListener("DOMContentLoaded", function() {
    TeamsFree.initComponents();
});
